interface DynamicTableData {
  headers: string[];
  body: any[];
}
interface Props {
  dynData: DynamicTableData;
}
function DynamicTableBody({ dynData }: Props) {
  const limitedBodyData = dynData.body; // Slice the data to show only the first 10 rows

  return (
    <tbody>
      {limitedBodyData?.map((bodyData) => (
        <>
          <tr
            key={bodyData?.uuid}
            className={
              bodyData?.Reels &&
              bodyData?.Reels?.toLowerCase()?.includes('reel')
                ? 'lightRed-color'
                : ''
            }
          >
            {dynData.headers?.map((headerName, index: number) => (
              <td
                key={headerName}
                className={index === 0 ? 'lightRed-color' : ''}
              >
                {typeof bodyData[headerName] === 'object'
                  ? JSON.stringify(bodyData[headerName])
                  : bodyData[headerName]}
              </td>
            ))}
          </tr>
        </>
      ))}
    </tbody>
  );
}

export default DynamicTableBody;
